import { render, staticRenderFns } from "./ConfigCenter.vue?vue&type=template&id=77a06a8e&scoped=true"
import script from "./ConfigCenter.vue?vue&type=script&lang=js"
export * from "./ConfigCenter.vue?vue&type=script&lang=js"
import style0 from "./ConfigCenter.vue?vue&type=style&index=0&id=77a06a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a06a8e",
  null
  
)

export default component.exports